<div
  (click)="toggle()"
  class="text-s1 flex select-none flex-row items-center space-x-2 px-5 pb-2 pt-2 text-xl font-semibold"
  [ngClass]="{
    'cursor-pointer': showToggle === true,
    'cursor-default': showToggle === false
  }"
>
  <div class="h-6 w-6" *ngIf="showToggle === false"></div>

  <m-chevron-right-icon
    *ngIf="showToggle === true && !isExpanded"
  ></m-chevron-right-icon>

  <m-chevron-down-icon
    *ngIf="showToggle === true && isExpanded"
  ></m-chevron-down-icon>

  <div> {{ title }} </div>
</div>
